class StickyBanner {
	constructor() {
		// eslint-disable-next-line no-console
		console.log("StickyBanner::initialize()")

		document.querySelectorAll(".bb-sticky-banner").forEach((el) => this._init(el))
	}

	_init(component) {
		const closeButton = component.querySelector(".bb-sticky-banner__close")
		const openButton = component.querySelector(".bb-sticky-banner__trigger")
		if (this._getCookie("sticky-banner-closed") === "true") {
			component.classList.remove("open")
		} else {
			component.classList.add("open")
		}
		component.classList.add("visible")

		closeButton.addEventListener("click", () => {
			component.classList.remove("open")
			this._setCookie("sticky-banner-closed", "true")
		})

		openButton.addEventListener("click", () => {
			component.classList.add("open")
			this._setCookie("sticky-banner-closed", "false")
		})
	}

	_setCookie(cname, cvalue) {
		document.cookie = cname + "=" + cvalue + ";"
	}

	_getCookie(cname) {
		let name = cname + "="
		let decodedCookie = decodeURIComponent(document.cookie)
		let ca = decodedCookie.split(";")
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i]
			while (c.charAt(0) === " ") {
				c = c.substring(1)
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length)
			}
		}
		return false
	}
}

export default StickyBanner
